
    import Player from "@vimeo/player";
    import Vue from "vue";

    export default Vue.extend({
        name: "TutorialVideo",
        props: {
            videoVimeoId: {
                type: Number
            },
            title: {
                type: String,
                default: ""
            },
            bodyText: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                videoWidth: 400
            }
        },
        mounted() {
            let player = this.$refs["vimeoPlayer"];
            if (player) {
                player = new Player(player, {
                    id: this.videoVimeoId,
                    width: this.videoWidth
                });
            }
        }
    });
